// extracted by mini-css-extract-plugin
export const root = "Footer-module--root--2hEVX";
export const copyrights = "Footer-module--copyrights--1ZR78";
export const linksWrapper = "Footer-module--linksWrapper--17yp7";
export const links = "Footer-module--links--1BKb1";
export const recaptchaInfo = "Footer-module--recaptchaInfo--3-eoG";